module.exports = __webpack_public_path__ + "static/media/r48_thumb_even_big.52a74cdd.jpg";